<template>
  <v-main class="sms">
    <head>
      <meta name="viewport" content="width=device-width,initial-scale=1.0">
    </head>
    <link href="tablet.css" rel="stylesheet" type="text/css" media="(min-width: 320px) and (max-width: 639px)" >
    <link href="tablet.css" rel="stylesheet" type="text/css" media="(min-width: 640px) and (max-width: 1023px)" >
    <link href="desktop.css" rel="stylesheet" type="text/css" media="(min-width: 1024px)" >
    <v-card
      class="all mx-auto my-16 py-4 px-16 "
      width="1000"
      height="auto"
      color="white"
      elevation="0"
    >
    <div class="text-center">
      <div class="title1">アカウント作成の前にSMS認証を行います</div>
      <div class="title2 pt-12 pb-8" style="font-size:14px;">
      SMS認証とは、スマートフォン・携帯電話の電話番号に認証番号をSMSに送信・照合し、<span style="color:#BA0009;">本人確認を行う認証手段の一つ</span>です
      <br>SMS認証によって、これから作成する<span style="color:#BA0009;">アカウントの不正利用を防ぐ目的</span>があります
      <br>ご自身の電話番号を入力してください
      
      <v-card
      width="300"
      class="mx-auto"
      elevation="0"
      >
      <div class="phonenumber">携帯電話番号</div>
        <v-text-field
          class="px-4 text"
          v-model="tel"
          width="50px"
          :rules="telrule"
        ></v-text-field>
      <div class="title3">半角英数字で入力</div>
      </v-card>
        <v-btn
          id="send-code-button"
          large
          outlined
          class="my-16  font-weight-bold"
          color="#008CFF"
          style="text-transform: none; font-family: mplus-2c-bold; font-size: 20px; border-width: 2px;"
          width="190px"
          :disabled="tel.length < 10 || tel.length > 13"
          @click="sendPhoneCode()"
        >
          送信
        </v-btn>
      </div>
      <v-btn
        class="back"
        color="black"
        text
        large
        href="/home"
        >
        <div class="modoru">
          <span style="color:#008CFF">＜</span> &nbsp; &nbsp;戻る &nbsp; &nbsp;<span style="color:#008CFF">＞</span>
        </div>
      </v-btn>
    </div>  
    </v-card>
  </v-main>
</template>

<script>
import firebase from 'firebase'

export default {
  data: () => ({
    tel: '',
    ttel: '',
    telrule: [v => v.length <= 13 || '電話番号を正しく入力して下さい。'],
    countryCode: "+81",
    recaptchaVerifier: null,
    result: null
  }),
  name: 'sms',
  mounted() {
    this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('send-code-button', {
      size: 'invisible'
    })
    firebase.auth().signOut()
  },
  methods: {
    async sendPhoneCode() {
      if (!this.tel) {
        alert('携帯電話の番号を入力してください')
      }
      this.ttel = this.tel.slice(1)
      const formattedPhpneNumber = this.countryCode + this.ttel
      try {
        //console.log("START"+formattedPhpneNumber)
        const confirmationResult = await firebase.auth().signInWithPhoneNumber(formattedPhpneNumber, this.recaptchaVerifier)
        this.result = JSON.stringify(confirmationResult)
        sessionStorage.setItem('result', this.result)
        this.$router.push('certification')
      } catch(e) {
        alert('入力内容に誤りがございます')
        //console.log(e)
      }
    }
  }
}
</script>

<style scoped>
*{
  font-family:mplus-2c-medium;
}
/*====================
PCを基本設計にする
 - 1280px〜：大型PC
 - 960px〜1279px：小型PC
 - 600px〜959px：タブレット
 - 480px〜599px：スマートフォン横
 - 〜479px：スマートフォン縦
====================*/

/* 1280px〜：大型PC
------------------------------ */
@media screen and (min-width:1280px) {
.all{
  position: relative;
  top:10%;
  left: 0%;
}
.title1{
  font-family:mplus-2c-light;
  font-size: 40px;
}
.phonenumber{
  position: relative;
  font-size: 20px;
  top: 30px;
  left: -90px;
}
.text{
  position: relative;
  top: 30px;
}
.title3{
  position: relative;
  left: 70px;
  top: 10px;
}
.modoru{
  font-size:36px;
}
}

/* 960px〜1279px：小型PC
------------------------------ */
@media screen and (min-width:960px) and (max-width:1279px) {
.all{
  position: relative;
  top:0%;
  left: 0%;
}
.title1{
  font-family:mplus-2c-light;
  font-size: 40px;
}
.phonenumber{
  position: relative;
  font-size: 20px;
  top: 30px;
  left: -90px;
}
.text{
  position: relative;
  top: 30px;
}
.title3{
  position: relative;
  left: 70px;
  top: 10px;
}
.modoru{
  font-size:30px;
}
}

/* 600px〜959px：タブレット
------------------------------ */
@media screen and (min-width:600px) and (max-width:959px) {
.all{
  position: relative;
  top:0%;
  left: 0%;
}
.title1{
  font-family:mplus-2c-light;
  font-size: 35px;
}
.phonenumber{
  position: relative;
  font-size: 20px;
  top: 30px;
  left: -90px;
}
.text{
  position: relative;
  top: 30px;
}
.title3{
  position: relative;
  left: 70px;
  top: 10px;
}
.modoru{
  font-size:30px;
}
}

/* 480px〜599px：SP横
------------------------------ */
@media screen and (min-width:480px) and (max-width:599px) {
.all{
  position: relative;
  top:0%;
  left: 0%;
}
.title1{
  font-family:mplus-2c-light;
  font-size: 35px;
}
.phonenumber{
  position: relative;
  font-size: 20px;
  top: 30px;
  left: -90px;
}
.text{
  position: relative;
  top: 30px;
}
.title3{
  position: relative;
  left: 70px;
  top: 10px;
}
.modoru{
  font-size:30px;
}
}

/* 〜479px：スマートフォン縦
------------------------------ */
@media screen and (max-width:479px) {
.all{
  position: relative;
  top:-5%;
  left: 0%;
}
.title1{
  font-family:mplus-2c-light;
  font-size: 29px;
}
.phonenumber{
  position: relative;
  font-size: 20px;
  top: 30px;
  left: -90px;
}
.text{
  position: relative;
  top: 30px;
}
.title3{
  position: relative;
  left: 70px;
  top: 10px;
}
.modoru{
  font-size:30px;
}
}





</style>
